import { render, staticRenderFns } from "./PmwLink.vue?vue&type=template&id=348741e6&scoped=true&"
import script from "./PmwLink.vue?vue&type=script&lang=js&"
export * from "./PmwLink.vue?vue&type=script&lang=js&"
import style0 from "./PmwLink.vue?vue&type=style&index=0&id=348741e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348741e6",
  null
  
)

export default component.exports